export enum Source {
    Home = 'product_home',
    Detail = 'product_detail',
    DetailCta = 'product_detail_cta',
}
export enum Product {
    Package = 'package',
}
export enum VerticalType {
    Hotel = 'hotel',
    HolidayHome = 'holidayHome',
    Cmx = 'cmx',
}
export enum OriginStep {
    Home = '10',
    S2 = '20',
    S3 = '30',
    S4 = '40',
    Sem = '13',
}
export enum PageType {
    Home = 'home',
    Region = 'travelsearch/region',
    Hotel = 'travelsearch/hotel',
    Offer = 'travelsearch/offer',
    Sem = 'sem',
}
